import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { size = 24 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M20 9V3.75a.75.75 0 00-.75-.75H2.75a.75.75 0 00-.75.75v13.5c0 .414.336.75.75.75H9.5M6.125 7.5H16M6.125 10.5H16M6 13.5h7.5M16.345 20.625H14.25a.375.375 0 01-.375-.375v-2.095a.37.37 0 01.108-.263l5.625-5.625a.375.375 0 01.534 0l2.09 2.09a.376.376 0 010 .535l-5.624 5.625a.37.37 0 01-.263.108v0zM18.375 13.5L21 16.125"
      />
    </svg>
  );
}

export default Icon;
